export const ActionTypes = {
	SET_TOKEN: "SET_TOKEN",
	SET_TENANTS: "SET_TENANTS",
	SELECTED_TENANT: "SELECTED_TENANTS",
	SET_USERS: "SET_USERS",
	FILTERED_USERS: "FILTERED_USERS",
	SET_SEARCH_TEXT: "SET_SEARCH_TEXT",
};
